import { buttonHoverClick } from '../elements/button'
import { breakpointUp } from '../utils/breakpoints'

const $body = $('body')
const $html = $('html')
const $videoModal = $('.modal-video')
const $video = $('#video-src')

$body.on('click', '.js-open-video', function (e) {
  e.preventDefault()
  let src = $(this).data('video-src')

  openVideoModal(src)

})

$body.on('click', '.js-follow-mouse-open-video', function (e) {
  e.preventDefault()
  let src = $(this).data('video-src')

  buttonHoverClick('.follow-cursor')

  // if($(window).width() >= 1280) {
  //   console.log($(this))
  //   console.log($(this).siblings('.svg-rect'))
  //   console.log($(this).closest('.small-video'))
  //   let svg = $(this).closest('.svg-rect')
  //   svg.css({strokeDashoffset: svg.attr('data-hover'), transition: 'all 1s'})
  //
  //   setTimeout(function () {
  //     svg.css({strokeDashoffset: svg.attr('data-default'), transition: 'none'})
  //   }, 1050)
  //
  //   setTimeout(function () {
  //     openVideoModal(src)
  //   }, 1025)
  // } else {
  //   openVideoModal(src)
  // }
  openVideoModal(src)
})

$body.on('click', '.modal-video-close', function (e){
  e.preventDefault()

  hideVideoModal()
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    hideVideoModal()
  }
})

function hideVideoModal() {
  $videoModal.removeClass('modal-visible')
  $html.removeClass('modal-visible')
  $video.attr('src', '')

  //window.history.pushState(null, null, document.location)
}

function historyListener(event) {
  hideVideoModal()
}

function openVideoModal(src) {

  //window.history.pushState('#video', "Modal video", document.location+'#video')

  //window.addEventListener('popstate', historyListener, false)

  $video.attr('src', src)

  setTimeout(function() {

    $video[0].play()

    $videoModal.addClass('modal-visible')
    $html.addClass('modal-visible')
  }, 5)

}

function closeVideoModal() {

  if ( window.history.state === '#video' ) {
    history.go(-1)
  }

  window.removeEventListener('popstate', historyListener)
}
